import { Card, TextField } from "@bruntworkwear-apps/ui";
import styles from "../UploadForm.module.css";

interface RunSettingsProps {
  landingRate: string;
  rateError: string | null;
  lookbackDays: string;
  lookbackError: string | null;
  disabled: boolean;
  onLandingRate: (value: string) => void;
  onLookbackDays: (value: string) => void;
}

/**
 * The flat landing rate and lookback window - the two settings that apply to
 * every line except where a dated band or a Boot Barn wholesale rate
 * overrides them.
 *
 * Split out of {@link ../UploadForm.view.tsx} to keep that file under its line
 * budget; markup only, same as every other view in this folder.
 *
 * @example
 * <RunSettings landingRate="2.29" rateError={null} lookbackDays="120"
 *   lookbackError={null} disabled={false} onLandingRate={setRate}
 *   onLookbackDays={setLookback} />
 */
export function RunSettings(props: RunSettingsProps) {
  const {
    landingRate,
    rateError,
    lookbackDays,
    lookbackError,
    disabled,
    onLandingRate,
    onLookbackDays,
  } = props;

  return (
    <Card title="Settings">
      <div className={styles.settings}>
        <TextField
          label="Landing rate"
          prefix="$"
          inputMode="decimal"
          value={landingRate}
          error={rateError}
          hint="Per unit, unless a dated rate below covers the line. USA and Boot Barn wholesale lines use the freight actually paid instead."
          onChange={(event) => onLandingRate(event.target.value)}
          disabled={disabled}
        />
        <TextField
          label="Lookback window"
          inputMode="numeric"
          value={lookbackDays}
          error={lookbackError}
          hint="Days back from the close month end."
          onChange={(event) => onLookbackDays(event.target.value)}
          disabled={disabled}
        />
      </div>
    </Card>
  );
}
